import Text from 'components/Text'
import Button from 'components/Button'
import './LandingExpress.styl'

const LandingExpress = ({ blok }) => {
  return (
    <div className="landing-express-container-express" id="BoletoExpress">
      <div className="content-express">
        <div className="description-express">
          <Text h2 size={1} className="label-text-express">
            {blok.Title} <span>{blok.boldText}</span>
          </Text>

          <Text p size={1} className="main-text-express">
            {blok.subTitle}
          </Text>

          <Button
            type="link"
            isExternalLink={true}
            to={blok.linkButton}
            className="button_express"
            role="button"
            data-make-location="lp"
            data-make-position="lp-cta"
            data-make-actionoutcome="redirect"
            data-make-element="button"
            data-make-outboundurl={blok.linkButton}
          >
            {blok.buttonText}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default LandingExpress
